import { css } from '@emotion/react';
import { useMemo, useState } from 'react';
import {
  CompanyPeriodRequestStatus,
  DataPointPeriodicity,
} from '../../../schemas/CompanyPeriodRequest.schema';
import { CompanyPeriodRequestManageViewModel } from './company-period-request.view-model';
import { CompanyPeriodRequestManageGrid } from './CompanyPeriodRequestManageGrid';
import { KpiDocsExportButton } from './KpiDocsExportButton';
import { KpiManageMenuBarV2 } from './KpiManageMenuBarV2';
import { AvailablePeriod, getExportDateRange } from './manage-request-utils';

const wrapperCss = css`
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;
  padding: 1rem;
  row-gap: 0.5rem;
  width: 100%;
  min-width: 0;
`;

interface CompanyPeriodRequestManageV2Props {
  requests: CompanyPeriodRequestManageViewModel[];
  requestStats: Map<CompanyPeriodRequestStatus | string, number>;
  availablePeriods: AvailablePeriod[];
  allStatuses: CompanyPeriodRequestStatus[];
  selectedFrequency: DataPointPeriodicity;
  onFrequencyChange: (frequency: DataPointPeriodicity) => void;
  selectedPeriod: string;
  onPeriodChange: (period: string) => void;
}

export function CompanyPeriodRequestManageV2(props: CompanyPeriodRequestManageV2Props) {
  const {
    requests,
    requestStats,
    availablePeriods,
    allStatuses,
    selectedFrequency,
    onFrequencyChange,
    selectedPeriod,
    onPeriodChange,
  } = props;
  const [selectedStatus, setSelectedStatus] = useState('All');

  const exportDateRange = useMemo(
    () => getExportDateRange(selectedPeriod, availablePeriods, selectedFrequency),
    [selectedPeriod, availablePeriods, selectedFrequency]
  );

  return (
    <div css={wrapperCss}>
      <KpiManageMenuBarV2
        allStatuses={allStatuses}
        requestStats={requestStats}
        selectedStatus={selectedStatus}
        onSelectedStatusChange={setSelectedStatus}
        selectedFrequency={selectedFrequency}
        onFrequencyChange={onFrequencyChange}
        selectedPeriod={selectedPeriod}
        onPeriodChange={onPeriodChange}
        availablePeriods={availablePeriods}
        rightAction={
          <KpiDocsExportButton
            dateFrom={exportDateRange.dateFrom}
            dateTo={exportDateRange.dateTo}
            periodicity={selectedFrequency}
          />
        }
      />
      <div style={{ backgroundColor: 'white', borderRadius: '0.5rem', minWidth: 0 }}>
        <CompanyPeriodRequestManageGrid requests={requests} selectedStatus={selectedStatus} mode='v2' />
      </div>
    </div>
  );
}
